<template>
    <div class="fillcontain">
        <div class="table_container">
            <el-row>
                <el-button type="primary" @click="handleEdit(0, '','add')">新增门店</el-button>
            </el-row>
            <br/>
            <el-table
                :data="userTableData"
                style="width: 100%"
                v-loading="loading">
              <el-table-column label="logo图">
                <template slot-scope="scope">
                  <img :src="scope.row.logo.showThumbnail" v-if="scope.row.logo != null" width="50" height="50"/>
                </template>
              </el-table-column>
              <el-table-column
                label="店名"
                prop="name">
              </el-table-column>

              <el-table-column
                label="管理员帐号"
                prop="adminUser.account">
              </el-table-column>
              <el-table-column
                label="电话"
                prop="telephons">
              </el-table-column>


                <el-table-column
                    label="备注"
                    prop="note"
                    :show-overflow-tooltip="true"
                >
                </el-table-column>

                <el-table-column
                    label="状态"
                    :formatter="rreezeFormat">
                </el-table-column>

                <el-table-column label="操作" width="280">
                  <template slot-scope="scope">
                    <el-button
                      size="mini"
                      style="margin: 5px"
                      @click="handleEdit(scope.$index, scope.row,'edit')">
                      编辑
                    </el-button>
                    <el-button
                      size="mini"
                      style="margin: 5px"
                      @click="goOtherPage('/mainStore/store/plugins',scope.row.id)">
                      插件配置
                    </el-button>
                    <el-button
                      size="mini"
                      style="margin: 5px"
                      @click="goOtherPage('/mainStore/store/h5_config',scope.row.id)">
                      H5点餐
                    </el-button>
                    <el-button
                      size="mini"
                      style="margin: 5px"
                      @click="goOtherPage('/mainStore/store/setting',scope.row.id)">
                      系统设置
                    </el-button>

                    <el-button
                      size="mini"
                      type="warning"
                      style="margin: 5px"
                      @click="handleResetPwdAlert( scope.row)">
                      重置密码
                    </el-button>
                    <el-button
                      size="mini"
                      type="danger"
                      style="margin: 5px"
                      @click="handleDeleteAlert( scope.row)">
                      删除
                    </el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="Pagination">
                <el-pagination
                  @size-change="handleSizeChange"
                  @current-change="handleCurrentChange"
                  :current-page="pages.page"
                  :page-size="pages.pageSize"
                  layout="total, prev, pager, next"
                  :total="pages.total">
                </el-pagination>
            </div>

            <el-dialog :title="dialog.title" :visible.sync="dialog.dialogFormVisible" style="z-index: 999990" :close-on-click-modal="dialog.close">
                <el-form :model="admin">
                    <el-form-item label="logo图片" label-width="80px">
                      <div style="text-align: left;margin: 5px">
                        <el-upload
                          :limit="picLimit"
                          :action="uploadUrl"
                          list-type="picture-card"
                          :on-preview="handlPicPreview"
                          :before-remove="handleBeforeRemove"
                          :on-success="handleSuccess"
                          :file-list="picFiles"
                        >
                          <i class="el-icon-plus"></i>
                        </el-upload>
                        <div v-show="picVisible" size="tiny">
                          <img width="100%" :src="picUrl" alt="">
                        </div>
                      </div>
                    </el-form-item>
                    <el-form-item label="账号" label-width="100px"  v-if="admin.id == 0">
                      <el-input v-model="admin.account" auto-complete="off"  maxlength="20" show-word-limit>
                        <template slot="prepend">{{storePrefix}}</template>
                      </el-input>
                      <br/>
                      <el-alert v-if="admin.account != ''"
                        :title="'帐号为：'+storePrefix+admin.account"
                        type="success"
                                :closable="false"
                      >
                      </el-alert>
                    </el-form-item>
                  <el-form-item label="账号" label-width="100px" v-else>
                    {{admin.account}}
                  </el-form-item>
                    <el-form-item label="密码" label-width="100px" v-if="admin.id == 0">
                      <span>初始密码为：888888</span>
                    </el-form-item>
                    <el-form-item label="店名" label-width="100px">
                        <el-input v-model="admin.name" auto-complete="off"  maxlength="20" show-word-limit></el-input>
                    </el-form-item>
                  <el-form-item label="地址" label-width="100px">
                    <el-row>
                      {{admin.province}} {{admin.city}} {{admin.area}}
                      <el-input v-model="admin.address" type="textarea" rows="4"></el-input>
                      <el-button @click="openMap()" v-if="map.dialogTableVisible == false">地图选择</el-button>
                      <el-button @click="map.dialogTableVisible = false" v-if="map.dialogTableVisible == true">关闭地图</el-button>
                    </el-row>
                    <el-row v-if="map.dialogTableVisible">
                      <el-row style="margin: 12px">
                        <el-col span="2">纬度(gcj02)：</el-col><el-col span="6"> <el-input v-model="infoWindow.lat"/></el-col>
                        <el-col span="2" style="margin-left: 15px">经度(gcj02)：</el-col><el-col span="6"> <el-input v-model="infoWindow.lng"/></el-col>
                      </el-row>
                      <el-row style="margin: 12px">
                        <el-col span="2">关键词：</el-col><el-col span="15"> <el-input v-model="map.keyword"/></el-col>
                      </el-row>
                      <baidu-map class="bm-view" ak="1cc46711df2cfe7b64df9bfb2d914492" @ready="map_handler" :center="nowPlace" :scroll-wheel-zoom="true" :double-click-zoom="false" @click="getPoint">
                        <BaiduMapNavigation anchor="BMAP_ANCHOR_TOP_RIGHT"></BaiduMapNavigation>
                        <BaiduMapMarker :position="{lng: admin.lng, lat: admin.lat}" :dragging="false" animation="BMAP_ANIMATION_BOUNCE" v-if="admin.lng">
                          <BaiduMapLabel :content="'地址:'+admin.province+admin.city+admin.area+admin.address"  :offset="{height: 25}"/>
                        </BaiduMapMarker>
                        <BaiduMapGeolocation anchor="BMAP_ANCHOR_BOTTOM_RIGHT" :showAddressBar="true" :autoLocation="true"></BaiduMapGeolocation>
                        <BaiduMapCityList anchor="BMAP_ANCHOR_TOP_LEFT"></BaiduMapCityList>
                        <BaiduMapType :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" :offset="{height: 45}" anchor="BMAP_ANCHOR_TOP_LEFT"></BaiduMapType>

                        <BaiduMapLocalSearch :keyword="map.keyword" :auto-viewport="true" :location="map.location"></BaiduMapLocalSearch>
                        <BaiduMapInfoWindow :position="{lng: infoWindow.lng, lat: infoWindow.lat}" title="位置信息" :show="infoWindow.show">
                          <br/>
                          <p v-text="'纬度（lat）:'+infoWindow.lat"></p>
                          <br/>
                          <p v-text="'经度（lng）:'+infoWindow.lng"></p>
                          <br/>
                          <p v-text="'地址:'+infoWindow.address"></p>
                          <br/>
                          <p><el-button type="success" @click="sureLatLng" size="mini">确定</el-button></p>
                        </BaiduMapInfoWindow>
                      </baidu-map>
                    </el-row>
                  </el-form-item>

                  <el-form-item label="电话" label-width="100px">
                    <el-input v-model="admin.telephons" auto-complete="off" maxlength="13" show-word-limit></el-input>
                  </el-form-item>


                  <el-form-item label="营业时间" label-width="100px">
                    <el-time-picker
                      v-model="admin.startTime"
                      value-format="HH:mm:ss"
                      placeholder="开始时间">
                    </el-time-picker>
                     至
                    <el-time-picker
                      v-model="admin.endTime"
                      value-format="HH:mm:ss"
                      placeholder="结束时间">
                    </el-time-picker>
                  </el-form-item>

                  <el-form-item label="状态" label-width="100px">
                    <el-radio v-model="admin.status" label="1">正常营业</el-radio>
                    <el-radio v-model="admin.status" label="2">上线但不营业</el-radio>
                    <el-radio v-model="admin.status" label="3">关闭门店</el-radio>
                  </el-form-item>
                  <el-form-item label="配置权限" label-width="100px">
                    <el-radio v-model="admin.configType" label="1">总店配置</el-radio>
                    <el-radio v-model="admin.configType" label="2">可分店配置</el-radio>
                  </el-form-item>


                  <el-form-item label="备注" label-width="100px">
                    <el-input v-model="admin.note" type="textarea" rows="4"></el-input>
                  </el-form-item>



                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialog.dialogFormVisible = false">取 消</el-button>
                    <el-button type="primary" @click="handleSave">确 定</el-button>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>

  import BaiduMap from 'vue-baidu-map/components/map/Map'
  import BaiduMapNavigation from 'vue-baidu-map/components/controls/Navigation'
  import BaiduMapGeolocation from 'vue-baidu-map/components/controls/Geolocation'
  import BaiduMapMarker from 'vue-baidu-map/components/overlays/marker'
  import BaiduMapLabel from 'vue-baidu-map/components/overlays/Label'
  import BaiduMapCityList from 'vue-baidu-map/components/controls/CityList'
  import BaiduMapType from 'vue-baidu-map/components/controls/MapType'
  import BaiduMapInfoWindow from 'vue-baidu-map/components/overlays/InfoWindow'
  import BaiduMapLocalSearch from 'vue-baidu-map/components/search/LocalSearch'
  export default {
    components: { BaiduMap,BaiduMapNavigation,BaiduMapMarker,BaiduMapLabel,BaiduMapGeolocation,BaiduMapCityList,BaiduMapType,BaiduMapLocalSearch,BaiduMapInfoWindow },
    data(){
          return {
              picLimit:1,
              uploadUrl:window.server.baseUrl+'/common/imageUpload',
              loading:false,
              nowPlace:"",
              map:{
                keyword:"",
                location:"",
                BMap:null,
                dialogTableVisible:false,
              },
              infoWindow:{
                show:false,
                lat:"",
                lng:"",
                address:"",
                province:"",
                city:"",
                area:""
              },
              admin:{
                  id:0,
                  account:"",
                  name:"",
                  province:"",
                  city:"",
                  area:"",
                  address:"",
                  telephons:"",
                  note:"",
                  status:"0",
                  startTime:"",
                  endTime:"",
                  //configType:"1",
                  payConfig:"1",
                  orderGoodsType:"1",
                  configType:"1"
              },
              storePrefix:"",
              dialog:{
                  dialogFormVisible:false,
                  title:"新增分店",
                  close:false,
              },
              pages:{
                  offset: 0,
                  pageSize: 10,
                  page: 1,
                  total: 0,
              },
              userTableData: [],
              login_url:"",

              picFiles:[],
              picVisible:false,
              picUrl:"",
          }
      },
      created(){
          var storage = window.localStorage;
          var user = JSON.parse(storage["user"]);
          this.storePrefix = user.mainStore.storePrefix;
          this.initData();
      },
      methods: {
          initData(){
            this.loading = true;
            var that = this;
            that.$api.get('/main_store/store', that.pages, response => {
              if (response.status >= 200 && response.status < 300) {
                var res = response.data;
                if (res.code == 0) {
                  that.userTableData = res.data.stores.content;
                  that.login_url = res.data.login_url;
                  that.pages.total = res.data.stores.totalElements;
                }else{
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
              } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });
              }
              this.loading = false;
            });
          },

          handleSizeChange(val) {
              console.log(`每页 ${val} 条`);
          },
          handleCurrentChange(val) {
              this.pages.page = val;
              this.pages.offset = (val - 1)*this.pages.pageSize;
              this.initData()
          },
          rreezeFormat(row){
              if(row.status == 1) {
                return "正常营业";
              }else if(row.status == 2){
                return "已上线未营业";
              }else if(row.status == 3){
                return "已关闭";
              }
          },

          handleBeforeRemove(file, fileList){
            var that = this;
            this.$confirm('此操作将删除该图片, 是否继续?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).then(() => {
              that.handleRemove(file, fileList);
            }).catch(() => {

            });
            return false;
          },
          handleRemove(file, fileList) {
            console.log(file);
            var index = this.picFiles.indexOf(file);
            console.log(index);
            if (index > -1) {
              this.picFiles.splice(index, 1);
            }
            console.log(this.picFiles)
          },
          handleSuccess(response,file, fileList) {
            file.id = response.ids[0];
            console.log(response);
            file.url = response.thumbnails[0];
            file.downloadUrl = response.data[0];
            file.md5 = response.md5s[0];
            file.ext = response.exts[0];
            this.picFiles.push(file);
          },
          handlPicPreview(file) {
            console.log(file);
            //BMP,JPG、JPEG、PNG
            if(file.ext.toLowerCase() == ".jpg" || file.ext.toLowerCase() == ".bmp" || file.ext.toLowerCase() == ".jpeg" || file.ext.toLowerCase() == ".png"){
              if(this.picUrl == file.downloadUrl){
                this.picVisible = !this.picVisible;
              }else{
                this.picVisible = true;
              }
              this.picUrl = file.downloadUrl;

            }else{
              this.picVisible = false;
              location.href = file.downloadUrl;
            }

          },

          handleEdit(index, row,action) {
              this.picFiles = new Array();
              if(action == "edit"){
                  this.dialog.title = "修改分店";
                  this.admin.id = row.id;
                  this.admin.account = row.adminUser.account;
                  this.admin.name = row.name;
                  this.admin.province = row.province;
                  this.admin.city = row.city;
                  this.admin.area = row.area;
                  this.admin.address = row.address;
                  this.admin.telephons = row.telephons;
                  this.admin.note = row.note;
                  this.admin.lat = row.lat;
                  this.admin.lng = row.lng;

                  this.infoWindow.lat = row.lat;
                  this.infoWindow.lng = row.lng;

                  this.admin.startTime = row.startTime;
                  this.admin.endTime = row.endTime;
                  this.admin.payConfig = ""+row.payConfig;
                  this.admin.configType = ""+row.configType;
                  this.admin.status = ""+row.status;
                  this.admin.orderGoodsType = ""+row.orderGoodsType;
                  if(row.logo != null){//图片处理
                    var imgObj = row.logo;
                    var img = {name: imgObj.name, url: imgObj.showThumbnail,id:imgObj.id,downloadUrl:imgObj.showUrl,ext:imgObj.ext,md5:imgObj.md5}
                    this.picFiles.push(img);

                  }
                  this.dialog.dialogFormVisible = true;

              }else if(action == "add"){
                  this.dialog.title = "新增分店";
                  this.admin.id = 0;
                  this.admin.account = "";
                  this.admin.name = "";
                  this.admin.province = "";
                  this.admin.city = "";
                  this.admin.area = "";
                  this.admin.address = "";
                  this.admin.telephons = "";
                  this.admin.note = "";
                  this.admin.startTime = "";
                  this.admin.endTime = "";
                  this.admin.payConfig = "1";
                  this.admin.status = "1";
                  this.admin.configType ="0";
                  this.admin.orderGoodsType = "1";
                  this.admin.lat = this.infoWindow.lat;
                  this.admin.lng = this.infoWindow.lng;
                  this.dialog.dialogFormVisible = true;
              }
          },
          handleSave() {
              this.loading = true;
              var that = this;
              var that = this;
              if(that.picFiles.length > 0){
                that.admin.logo_file_md5 = this.picFiles[0].md5;
              }
            this.admin.lat = this.infoWindow.lat;
            this.admin.lng = this.infoWindow.lng;
              that.$api.post('/main_store/store', that.admin, response => {
                if (response.status >= 200 && response.status < 300) {
                  console.log(response.data);
                  var res = response.data;
                  if (res.code == 0) {
                    this.$message({
                      message: that.dialog.title+'成功',
                      type: 'success'
                    });
                    this.dialog.dialogFormVisible = false;
                    this.initData();
                  }else{
                    this.$message({
                      message: res.msg,
                      type: 'warning'
                    });
                  }
                } else {
                  this.$message({
                    message: "服务器维护中",
                    type: 'error'
                  });
                }

              });

              this.loading = false;
          },

        handleResetPwdAlert(row) {
          this.$confirm('此操作将重置该分店管理员的密码为:888888, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.handleResetPwd(row);
          }).catch(() => {

          });
        },

        handleResetPwd(row) {
          this.loading = true;
          var that = this;
          that.$api.put('/main_store/store/reset_password/'+row.id, null, response => {
            if (response.status >= 200 && response.status < 300) {
              console.log(response.data);
              var res = response.data;
              if (res.code == 0) {
                this.$message({
                  message: '重置成功,请立即使用默认密码:888888 登录修改密码',
                  type: 'success',

                });
                //this.initData();
              }else{
                this.$message({
                  message: res.msg,
                  type: 'warning'
                });
              }
            } else {
              this.$message({
                message: "服务器维护中",
                type: 'error'
              });
            }

            this.loading = false;

          });
        },
          handleDeleteAlert(row) {
              this.$confirm('此操作将删除该分店, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
              }).then(() => {
                  this.handleDelete(row);
              }).catch(() => {

              });
          },
        handleDelete(row) {
          this.loading = true;
          var that = this;
          that.$api.delete('/main_store/store/'+row.id, null, response => {
            if (response.status >= 200 && response.status < 300) {
                console.log(response.data);
                var res = response.data;
                if (res.code == 0) {
                  this.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.loading = false;
                  this.initData();
                }else{
                  this.$message({
                    message: res.msg,
                    type: 'warning'
                  });
                }
            } else {
                this.$message({
                  message: "服务器维护中",
                  type: 'error'
                });
            }

          });
        },
        map_handler({ BMap, map }) {
          console.log("map_handler")
          this.map.BMap = BMap;
          var geolocation =  new BMap.Geolocation();
          var _this = this
          console.log("eeee");
          geolocation.getCurrentPosition(function(r) {
            _this.nowPlace = r.address.city;
          })
        },
        openMap(){
          this.map.dialogTableVisible = true;

        },
        getPoint(e){
            console.log(e);
          this.infoWindow.lat = e.point.lat;
          this.infoWindow.lng = e.point.lng;
          this.handler(this.infoWindow.lng,this.infoWindow.lat)
          this.infoWindow.show = false;
          this.infoWindow.show = true;
          console.log(this.infoWindow.show);
        },
        handler(lng,lat){
          const that = this
          let BMap = this.map.BMap;
          var myGeo = new BMap.Geocoder();
          var pt = new BMap.Point(lng,lat);
          myGeo.getLocation(pt,function(result){
            console.log(result.addressComponents);
            var addressInfo = result.addressComponents;
            that.infoWindow.province = addressInfo.province;
            that.infoWindow.city = addressInfo.city;
            that.infoWindow.area = addressInfo.district;
            that.infoWindow.address = addressInfo.street+addressInfo.streetNumber; //获取到当前定位的详细地址信息
          });
        },
        sureLatLng(e){
          console.log(e)
          //var addrData = {"addr":this.infoWindow.address,"lat":this.infoWindow.lat,"lng":this.infoWindow.lng};
          this.admin.province = this.infoWindow.province;
          this.admin.city = this.infoWindow.city;
          this.admin.area = this.infoWindow.area;
          this.admin.address = this.infoWindow.address;
          this.admin.lat = this.infoWindow.lat;
          this.admin.lng = this.infoWindow.lng;
          this.infoWindow.show = false;
          this.map.dialogTableVisible = false;
        },
        goOtherPage(path,store_id){
          this.$router.push({path:path,query: {store_id: store_id}});
        },
      },
  }
</script>

<style lang="less">
	@import '../../style/mixin';
    .demo-table-expand {
        font-size: 0;
    }
    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }
    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
        width: 50%;
    }
    .table_container{
        padding: 20px;
        text-align: left;
    }
    .Pagination{
        display: flex;
        justify-content: flex-start;
        margin-top: 8px;
    }
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 120px;
        height: 120px;
        line-height: 120px;
        text-align: center;
    }
    .avatar {
        width: 120px;
        height: 120px;
        display: block;
    }
</style>
<style lang="less">
.input{
  width: 12px;
}
</style>
<style>
.bm-view {
  width: 100%;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// src/pages/mainStore/Store.vue